import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import ListaProductos from "./ListaProductos";
import DefinicionVariable from "../../../../../rangoPrecios/ActualizacionPrecio/DefinicionVariable";
import { getData } from "../../../../../../../services/library";
import { UrlApi } from "../../../../../../../services/apirest";
import moment from "moment";
import DefinicionVariableEspecial from "./DefinicionVariableEspecial";

function ActualizarPrecioEspecial(props) {
  const [productos, setProductos] = useState([]);
  const [todosProductos, setTodosProductos] = useState(false);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [monto, setMonto] = useState("");
  const [porcentaje, setPorcentaje] = useState("");
  const [precioMinimo, setPrecioMinimo] = useState("");
  // const [precioMaximo, setPrecioMaximo] = useState("");
  const [tipoOperacion, setTipoOperacion] = useState("");
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

    //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  useEffect(() => {
    getData("/productos/envasados", (data) => setProductos(data));
  }, []);

  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);

  const handleMontoChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setMonto(value);
      if (value !== "") setPorcentaje("");
      setTipoOperacion("monto");
    }
  };

  const handlePorcentajeChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPorcentaje(value);
      if (value !== "") setMonto("");
      setTipoOperacion("porcentaje");
    }
  };

  const handlePrecioMinimo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMinimo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  // const handlePrecioMaximo = (e) => {
  //   const value = e.target.value;
  //   if (validarInput(value)) {
  //     setPrecioMaximo(value);
  //     if (value !== "") setMonto("");
  //     setTipoOperacion("precio");
  //   }
  // };

  const handleClose = () => {
    props.setOpen(false);
    props.actualizar();
  };  
  
    const handleActualizarPrecios = async (e) => {
      e.preventDefault();
  
      const valor = parseFloat(monto || porcentaje);
  
      const listaFiltrada = props.precioEspecial.filter(
        (item) =>
          productosSeleccionados.some((p) => p.idproducto === item.producto)
      );
  
      const listaActualizada = listaFiltrada.map((item) => {
        let nuevoMin = item.precio_minimo;
        // let nuevoMax = item.precio_maximo;
  
        if (tipoOperacion === "monto") {
          nuevoMin += valor;
          // nuevoMax += valor;
        } else if (tipoOperacion === "porcentaje") {
          const factor = valor / 100;
          nuevoMin += nuevoMin * factor;
          // nuevoMax += nuevoMax * factor;
        } else {
          nuevoMin = precioMinimo;
          // nuevoMax = precioMaximo;
        }
  
        return {
          id: item.id,
          precio_minimo: Math.round(nuevoMin),
          // precio_maximo: Math.round(nuevoMax),
        };
      });
  
try {
    // 1) Actualizo precios en lote
    const resp = await fetch(UrlApi + "/envasado_precios_especiales/multiple/", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(listaActualizada),
    });
    const data = await resp.json();

    if (!data.err) {
      // 2) Armo historial
      const historial = listaFiltrada.map((item, index) => {
        const actualizado = listaActualizada[index];
        return {
          producto: item.producto,
          cliente: item.cliente, // si lo tenés en la lista
          precio_minimo_anterior: item.precio_minimo,
          // precio_maximo_anterior: item.precio_maximo,
          precio_minimo_nuevo: actualizado.precio_minimo,
          // precio_maximo_nuevo: actualizado.precio_maximo,
          fecha: moment().format("YYYY-MM-DD"),
          usuario: localStorage.getItem("user"),
        };
      });

      // 3) Guardo historial
      await guardarHistorial(historial);

      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La variación se guardó exitosamente !");
    } else {
      console.log("Error al actualizar precios");
    }
  } catch (err) {
    console.error("Error actualizando precios", err);
  }
};

const guardarHistorial = async (historial) => {
  try {
    const resp = await fetch(`${UrlApi}/envasado_historial_especial/multiple`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(historial),
    });

    const data = await resp.json();
    if (!data.err) {
      console.log("Historial guardado correctamente");
    } else {
      console.error("Error guardando historial", data.err);
    }
  } catch (error) {
    console.error("Error en fetch historial:", error);
  }
};

  const isPrecioMinMaxValido = precioMinimo !== "" ;
const isMontoOPorcentajeValido = (monto !== "" || porcentaje !== "") && !isPrecioMinMaxValido;

const isGuardarDisabled =
  openSnack || // si está mostrando snackbar, bloquear
  productosSeleccionados.length === 0 || // si no hay productos
  (!isPrecioMinMaxValido && !isMontoOPorcentajeValido); // si no cumple ninguna condición


  return (
    <div>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Actualizar Precio Especial
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={6}>
              <Box display="flex" flexDirection="column" height="100%">
                <ListaProductos
                  productos={productos}
                  todosProductos={todosProductos}
                  setTodosProductos={setTodosProductos}
                  productosSeleccionados={productosSeleccionados}
                  setProductosSeleccionados={setProductosSeleccionados}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <DefinicionVariableEspecial
                monto={monto}
                porcentaje={porcentaje}
                precioMinimo={precioMinimo}
                // precioMaximo={precioMaximo}
                handleMontoChange={handleMontoChange}
                handlePorcentajeChange={handlePorcentajeChange}
                handlePrecioMinimo={handlePrecioMinimo}
                // handlePrecioMaximo={handlePrecioMaximo}
              />
            </Grid>
          </Grid>
        </DialogContent>
         <DialogActions
            sx={{
              justifyContent: "space-between",
              p: 1,
              position: "sticky",
              bottom: 0,
            }}
          >
            <Button
              color="error"
              variant="contained"
              onClick={handleClose}
              sx={{ minWidth: 120 }}
            >
              Volver
            </Button>
              <Button
                color="success"
                type="submit"
                variant="contained"
                sx={{ minWidth: 120 }}
                onClick={handleActualizarPrecios}
                disabled={isGuardarDisabled}
              >
                Confirmar
              </Button>
          </DialogActions>
      </Dialog>
            <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
}

export default ActualizarPrecioEspecial;
